import { getStepAnimation } from '../animations/fadepos'

// Fade per fragment, with an optional move from `start_position` like the element fade.
export function getTextFadeAnimation (element, settings) {
    return {
        from: getStepAnimation(element, settings, true),
    }
}
